import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M24.667 19.958 11.375 6.667h20.292q1.041 0 1.5.916.458.917-.167 1.75zm8.291 17.709-9.625-9.625v3.625q0 .708-.478 1.186-.48.48-1.188.48h-3.334q-.708 0-1.186-.48a1.6 1.6 0 0 1-.48-1.186V21.375L2.333 7.042l2.334-2.375 30.666 30.666z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }